import {initClickerGameDeps} from './modules/di.clicker-game';
import {initGCSDeps} from './modules/di.gcs';
import {initAuthDeps} from '@/di/modules/di.auth';
import {initDomainDeps} from '@/di/modules/di.domain';
import {initInfraDeps} from '@/di/modules/di.infra';

import {Container} from 'brandi';

import {ResourcesAll} from '@/resources';

export function createDiRootContainer(resources: ResourcesAll): Container {
  const container = new Container();

  initInfraDeps(container, resources);
  initAuthDeps(container);
  initDomainDeps(container);
  initGCSDeps(container);
  initClickerGameDeps(container);

  return container;
}
